export default "/img/CW.d7c9ecf4cb97a3cc35f51789d348544b.png";